import { render } from "./seating.vue?vue&type=template&id=3e6d3b1d&scoped=true"
import script from "./seating.vue?vue&type=script&lang=js"
export * from "./seating.vue?vue&type=script&lang=js"

import "./seating.vue?vue&type=style&index=0&id=3e6d3b1d&scoped=true&lang=css"
import "./seating.vue?vue&type=style&index=1&id=3e6d3b1d&lang=css"
script.render = render
script.__scopeId = "data-v-3e6d3b1d"

export default script